import { getInsFromPatient } from "./index";

export const extractGetDocumentsStatusParams = (data) => {
  const { ins } = getInsFromPatient(data);
  
  const { uniqueIds: { uniqueId } = {} } = data;
  let uniqueIds = uniqueId;
  if (uniqueId && !Array.isArray(uniqueId)) {
    uniqueIds = [uniqueId];
  }
  
  return {
    ins,
    uniqueIds: uniqueIds.map(id => id.value)
  }
}

export const extractJSONGetDocumentsStatusParams = (data) => {
  const { ins } = getInsFromPatient(data);
  
  const { uniqueIds } = data;
  
  return {
    ins,
    uniqueIds
  }
}